import script from "./auth.vue?vue&type=script&lang=ts&setup=true"
export * from "./auth.vue?vue&type=script&lang=ts&setup=true"

import "./auth.vue?vue&type=style&index=0&id=2a63e028&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2a63e028"]])

export default __exports__